/* eslint-disable import/no-unresolved */
import React from 'react';

import CourseItemCourseComponent from '../../components/CourseDashboard/CourseItem/CourseItemResource';

function FreeQuizCard({ data }) {
  return data?.map((item) => <CourseItemCourseComponent key={item?.quizId} item={item} />);
}

export default FreeQuizCard;
